export const dashboard = {
  title: "Dashboard",
  filters: {
    accommodation: "Alloggio",
    allAccommodations: "Tutti gli alloggi",
    period: "Periodo",
    periodOptions: {
      today: "Oggi",
      week: "Settimana",
      month: "Mese",
      year: "Anno",
    },
  },
  actions: {
    createBooking: "Crea prenotazione",
  },
  pendingWidget: {
    title: "Azioni in sospeso",
    subtitle: "Pagamenti, richieste e camere da assegnare.",
    oneRequest: "richiesta",
    manyRequests: "richieste",
    onePayment: "pagamento",
    manyPayments: "pagamenti",
    oneUnassigned: "da assegnare",
    manyUnassigned: "da assegnare",
    loading: "Caricamento azioni in sospeso...",
    emptyTitle: "Nessuna azione in sospeso",
    emptyText: "Quando arriva una nuova richiesta o una prenotazione è in attesa di pagamento, comparirà qui.",
    noName: "Senza nome",
    accommodation: "Alloggio",
    guest: "ospite",
    guests: "ospiti",
    requestShort: "Richiesta",
    pendingPaymentShort: "In attesa di pagamento",
    unassignedShort: "Assegna camera",
    approve: "Approva",
    reject: "Rifiuta",
    viewAll: "Visualizza tutte le prenotazioni",
    modalApproveTitle: "Approva richiesta",
    modalRejectTitle: "Rifiuta richiesta",
    modalApproveText1: "Stai per approvare la richiesta di",
    modalApproveText2: "Se questa prenotazione utilizza il pagamento online, passerà in attesa di pagamento.",
    modalRejectText1: "Stai per rifiutare la richiesta di",
    modalRejectText2: "Puoi indicare un motivo da inviare all'ospite via email.",
    rejectReasonLabel: "Motivo del rifiuto",
    rejectReasonPlaceholder: "Seleziona un motivo",
    reasonDatesUnavailable: "Le date non sono più disponibili",
    reasonPriceUnavailable: "La tariffa non è più disponibile",
    reasonMinimumStay: "Non soddisfa il soggiorno minimo",
    reasonHouseRules: "Non rispetta le regole dell'alloggio",
    reasonOther: "Altro motivo",
    rejectReasonOtherPlaceholder: "Scrivi il motivo del rifiuto",
    rejectReasonRequired: "Devi selezionare un motivo di rifiuto.",
    rejectReasonOtherRequired: "Devi scrivere il motivo del rifiuto.",
    cancel: "Annulla",
    confirmApprove: "Sì, approva",
    confirmReject: "Sì, rifiuta",
    statusUpdatedSuccess: "Stato aggiornato con successo.",
    statusUpdatedError: "Impossibile aggiornare lo stato."
  },

  stats: {
    totalReservations: {
      today:   "Prenotazioni di oggi",
      week:    "Prenotazioni di questa settimana",
      month:   "Prenotazioni di questo mese",
      year:    "Prenotazioni di quest'anno",
      default: "Prenotazioni totali",
    },
    checkIns: {
      today:   "Check-in di oggi",
      week:    "Check-in di questa settimana",
      month:   "Check-in di questo mese",
      year:    "Check-in di quest'anno",
      default: "Check-in",
    },
    occupancy: {
      today:   "Occupazione di oggi",
      week:    "Occupazione settimanale",
      month:   "Occupazione mensile",
      year:    "Occupazione annuale",
      default: "Occupazione",
    },
    revenue: {
      today:   "Ricavi di oggi",
      week:    "Ricavi settimanali",
      month:   "Ricavi mensili",
      year:    "Ricavi annuali",
      default: "Ricavi",
    },
  },
  section3: {
    title: "Prossime prenotazioni",
    subtitle: "Elenco dei prossimi arrivi per il tuo alloggio",
    timeFilters: {
      upcoming: "Prossimi",
      thisWeek: "Questa settimana",
      today: "Oggi",
      tomorrow: "Domani",
      month: "Mese",
    },
    table: {
      headers: {
        responsible: "Responsabile",
        checkInDate: "Data di check-in",
        entry: "Ingresso",
        guests: "Ospiti",
        status: "Stato",
      },
    },
    empty: {
      today: {
        title: "Non hai arrivi per oggi",
        description:
          "Quando avrai un nuovo arrivo previsto per oggi, comparirà qui con i suoi dettagli importanti.",
      },
      default: {
        title: "Non hai arrivi in programma",
        description:
          "Quando avrai nuovi arrivi in programma, compariranno qui insieme ai loro dettagli importanti.",
      },
    },
    loading: "Caricamento prenotazioni...",
    statuses: {
      inProgress: "In corso",
      complete: "Completata",
      pending: "In sospeso",
      approved: "Approvata",
    },
    actions: {
      replyOnWhatsApp: "Rispondi su WhatsApp",
    },
    nights: "{count} notte | {count} notti",
  },
  section4: {
    title: "Dettaglio dei ricavi",
    total: "Ricavi totali",
    emptyChart: "Nessun dato disponibile",
    noData: "Non ci sono dati sui ricavi da mostrare",
  },
  section5: {
    title: "Ricavi totali",
    datasetLabel: "Ricavi",
    filters: {
      weekly: "Settimanale",
      monthly: "Mensile",
      "6m": "6 mesi",
      "12m": "12 mesi",
      "24m": "24 mesi",
    },
    loading: "Caricamento dati...",
    errors: {
      load: "Errore durante il caricamento dei dati",
      connection: "Errore di connessione",
    },
  },
  design: {
    title: `Design del pannello`,
    reorder: `Riordina`,
    active: `Attivo`,
    theme: `Tema`,
    color: `Colore`,
    green: `Verde`,
    system: `Sistema`,
    white: `Bianco`,
    sidebar: `Barra laterale`,
    black: `Nero`,
  },
  earlyCheckin: {
    earlyShort: `Anticipato`,
    arrivesShort: `Arriva`,
    arrivalAt: `Alle {time}`,
    requested: `Check-in anticipato richiesto`,
    arrivalRequested: `Orario di arrivo richiesto`,
  },
};
